export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/am.1508d3f6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};